module.exports = __webpack_public_path__ + "img/Jhakaas-png.98c1f175.png";